import {register} from '../vendor/theme-scripts/theme-sections';
import MicroModal from 'micromodal';

const selectors = {
  videoPopup: '[data-video-popup]',
  videoAutoplay: '[data-video-autoplay] video',
  attrPlayer: 'data-popup-video-wrapper',
};

class VideoSliderPopup {
  constructor(section) {
    this.container = section.container;
    this.triggers = this.container.querySelectorAll(selectors.videoPopup);
    this.backgroundVideo = this.container.querySelector(selectors.videoAutoplay);

    this.init();
  }

  init() {
    this.triggers.forEach((trigger) => {
      const sectionId = trigger.getAttribute('data-section-id')
      const blockId = trigger.getAttribute('data-block-id')
      const player = document.querySelector(`[${selectors.attrPlayer}="${sectionId}-${blockId}"] > video`)

      // Modal Event Logic:
      // When a modal opens it creates and plays the video
      // When a modal opens it pauses background videos in this section
      // --
      // When a modal closes it destroys the player
      // When a modal closes it plays background videos anywhere on the page
      MicroModal.init({
        onShow: () => {
          // if (this.backgroundVideo && typeof this.backgroundVideo.pause === 'function') {
          //   this.backgroundVideo.pause();
          // }
          if (player && typeof player.play === 'function') {
            player.play();
          }
        },
        onClose: (modal, el, event) => {
          event.preventDefault();
          // if (this.backgroundVideo && typeof this.backgroundVideo.play === 'function') {
          //   this.backgroundVideo.play();
          // }
          if (player && typeof player.pause === 'function') {
            player.pause();
          }
        },
        openTrigger: `data-trigger-${sectionId}-${blockId}`,
      });
    });
  }
}

const videoSliderSection = {
  onLoad() {
    new VideoSliderPopup(this);
  },
};

register('section-video-slider', videoSliderSection);
